import React from "react";

export default function ThankYou() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#1E2A38] text-white px-4">
      <div className="bg-[#2C3A4B] rounded-xl p-10 max-w-md text-center shadow-lg">
        <h1 className="text-4xl font-extrabold mb-4">Thank You!</h1>
        <p className="text-white/80 mb-6">
          Your message has been successfully sent. We’ll get back to you
          shortly.
        </p>
        <a
          href="/"
          className="inline-block px-6 py-3 bg-[#F9DC5C] text-black font-semibold rounded-md hover:brightness-95 transition"
        >
          Back to Home
        </a>
      </div>
    </div>
  );
}
